.glyph {
    background-color: var(--color-black);
    border-radius: 29px;
    color: #ffffff;
    font-size: 1.875rem;
    margin: 0 auto 4px;
    position: relative;
    padding: 6px;
    text-align: center;
    width: 58px;
}
